import { ContactLinkNonCollapsible, LegalList, Logo, UspList } from '../components';
import type { FooterProps } from '../types';

/**
 * Footer variant for cart pages
 * Renders: USPs → Contact → Legals → Logo
 */
export function FooterCart(props: FooterProps) {
  const { contact, device } = props;

  return (
    <>
      <UspList {...props} />
      {contact && (
        <ContactLinkNonCollapsible
          align="left"
          direction="column"
          flow="column"
          contact={contact}
          device={device}
          type="customer-support"
        />
      )}
      <LegalList {...props} />
      <Logo />
    </>
  );
}
